import styled from 'styled-components'

export const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const Subtitle = styled.div`
  margin-bottom: ${props => props.theme.spacing.sp16};
`
